import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon  } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';

import adminfaculty from '../adminfaculty/adminfaculty';
import Modalexpert from './Modalexpert';
import Commentexlist from './Commentexlist';
//import Modalarticletyps from './Modalarticletypes';



export default class expert extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[],
            extertype:'',
            expert_id:'',
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
         this.selectex = this.selectex.bind(this);
         this.dow = this.dow.bind(this);
         this.extertype = this.extertype.bind(this);
         
      }


    componentDidMount() {

         setTimeout(() => {
           
            Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectExpertat.php?idexpert='+localStorage.getItem('expert_id') )
           .then(res => {
         //    console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
             this.setState({ expert_id: localStorage.getItem('expert_id')})
           }) 

         }, 0);

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        // if (localStorage.getItem('nameuser') === null) {
        //     window.location.href = '/'
        // } else {
        // }
        this.extertype();


      }

      selectex() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
        }
        setTimeout(() => {
           
            Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectExpertat.php?idexpert='+localStorage.getItem('expert_id') )
           .then(res => {
          //   console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 

         }, 0);



      }

      extertype() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
        }
        setTimeout(() => {
           
            Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectExpertattype.php?idexpert='+localStorage.getItem('expert_id') )
           .then(res => {
             console.log(res.data[0].expert_type);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ extertype: res.data[0].expert_type})
           }) 

         }, 0);



      }

      updateat(){
        setTimeout(() => {
           
          Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticle.php')
         .then(res => {
         //  console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 
       }, 0);
      }

      dow(){
       
           
          if (localStorage.getItem('expert_id') !== null) {

              if (this.state.extertype === '1') {
                 window.open(
                    'https://edu.kpru.ac.th/conference/PHPAPI/TCPDF-main/invite.php?expert_id='+localStorage.getItem('expert_id') ,
                    '_blank' // <- This is what makes it open in a new window.
                  );
              }else{
                window.open(
                  'https://edu.kpru.ac.th/conference/PHPAPI/TCPDF-main/invite2.php?expert_id='+localStorage.getItem('expert_id') ,
                  '_blank' // <- This is what makes it open in a new window.
                );

              }

           // window.location.href = 'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/invite.php?expert_id='+localStorage.getItem('expert_id') 
           

        } else {
        }
      }



    render() {
        return (
            <MDBContainer>
            <div>
            <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} (ผู้ทรงคุณวุฒิ)</p>
                <p className="text-right">การประชุมวิชาการระดับชาติครุศาสตร์ศึกษา ครั้งที่ 8 มหาวิทยาลัยราชภัฏกำแพงเพชร</p> 
            {/* <Alert message="แบบพอร์มสำหรับพิจารณาบทความ" type="info" /> */}
            {/* <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>รายการ</th>
                        <th>ไฟล์เอกสาร</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                   
                        <tr>
                        <td>1</td>
                        <td>แบบตอบรับการเป็นผู้ทรงคุณวุฒิ</td>
                        <td><a href="https://conference.kpru.ac.th/adminconference-sd/download/exp2.pdf"> <MDBBtn color="primary" size="sm">Download</MDBBtn></a></td>
                        </tr>
                        <tr>
                        <td>2</td>
                        <td>คำชี้แจงการเขียนบทความ</td>
                        <td><a href="https://conference.kpru.ac.th/adminconference-sd/download/exp3.pdf"> <MDBBtn color="primary" size="sm">Download</MDBBtn></a></td>
                        </tr>
                        <tr>
                        <td>3</td>
                        <td>หนังสือขอความอนุเคราะห์ตรวจบทความ</td>
                        <td>{this.state.extertype === '1' || this.state.extertype === '2' ? <><MDBBtn color="primary" size="sm" onClick={this.dow}>Download</MDBBtn></> : <></>}</td>
                        </tr>
                        <tr>
                        <td>4</td>
                        <td>แบบประเมิน บทความวิจัย สาขามนุษยศาสตร์และสังคมศาสตร์</td>
                        <td><a href="https://conference.kpru.ac.th/adminconference-sd/download/hum1.docx"><MDBBtn color="primary" size="sm">Download</MDBBtn></a></td>
                        </tr>
                      
                        <tr>
                        <td>5</td>
                        <td>แบบประเมิน บทความวิจัย  สาขาวิทยาศาสตร์และเทคโนโลยี</td>
                        <td><a href="https://conference.kpru.ac.th/adminconference-sd/download/sai1.docx"><MDBBtn color="primary" size="sm">Download</MDBBtn></a></td>
                        </tr> 
                        <tr> 
                        <td>6</td>
                        <td>ใบสำคัญรับเงิน</td>
                        <td><a href="https://conference.kpru.ac.th/adminconference-sd/download/money.pdf"><MDBBtn color="primary" size="sm">Download</MDBBtn></a></td>
                        </tr>
                        <tr>
                        <td>7</td>
                        <td>คู่มือการการใช้งานระบบ สำหรับผู้ทรงคุณวุฒิ</td>
                        <td><a href="https://conference.kpru.ac.th/adminconference-sd/download/exp1.pdf" target="_blank" ><MDBBtn color="primary" size="sm">Download</MDBBtn></a></td>
                        </tr>
                    
                    </MDBTableBody>
                </MDBTable> */}



               <MDBAlert color="success" >
                   <h2><MDBIcon icon="book-open" className="green-text pr-3" /> บทความเข้าใหม่</h2>
                </MDBAlert>
                <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความสำหรับตรวจ</th>
                        {/* <th>จัดการ</th> */}
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.article.map((article,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{article.send_name}</td>
                        <td>{article.major_precent}</td>
                        <td>
                            {/* <MDBBtn color="indigo" size="sm" href={article.sendclose_uploadeword1}  target="_blank">WORD</MDBBtn> */}
                            <Commentexlist id_send={article.id_send} expert_id={this.state.expert_id}  />
                             </td>
                         <td>
                             {/* { article.stapat >= 3 ? <><MDBBtn color="deep-orange">ส่งคืนบทความแล้ว</MDBBtn></>: <><Modalexpertbn  id_send={article.id_send} namearticla={article.send_name} expert_id={this.state.expert_id} selectex={this.selectex} /></>}  */}
                             </td>
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable>

            </div>
            </MDBContainer>
        )
    }
}
